import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

export const buildSiteForm = (formBuilder: UntypedFormBuilder): UntypedFormGroup => {
  return formBuilder.group({
    id: ['', Validators.required],
    name: ['', Validators.required],
    plantCode: '',
  });
};
